if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.section;
      }

      connectedCallback() {
        this.initElements();
        this.setupEventListeners();
        this.moveSellingPlanInputToForm();
        this.updatePriceDisplay();
      }

      disconnectedCallback() {
        // 清理事件监听器
      }

      initElements() {
        this.onetimeRadio = this.querySelector('.subscription-widget__onetime-radio');
        this.subscribeRadio = this.querySelector('.subscription-widget__subscribe-radio');
        this.sellingPlanSelect = this.querySelector('.subscription-widget__select');
        this.sellingPlanInput = this.querySelector('#selling-plan-input-' + this.sectionId);

        // 分别获取一次性购买和订阅选项中的价格显示元素
        const onetimeOption = this.querySelector('.subscription-widget__option--onetime');
        const subscribeOption = this.querySelector('.subscription-widget__option--subscribe');

        this.onetimePriceDisplay = onetimeOption?.querySelector('.subscription-widget__price-display');
        this.subscribePriceDisplay = subscribeOption?.querySelector('.subscription-widget__price-display');
        this.subscribeComparePriceDisplay = subscribeOption?.querySelector('.subscription-widget__compare-price');

        console.log('[SubscriptionWidget] initElements completed');
        console.log('[SubscriptionWidget] sellingPlanSelect found:', !!this.sellingPlanSelect, this.sellingPlanSelect);
        console.log('[SubscriptionWidget] subscribePriceDisplay found:', !!this.subscribePriceDisplay, this.subscribePriceDisplay);
        console.log('[SubscriptionWidget] All options in select:', this.sellingPlanSelect?.options?.length);

        // 打印每个 option 的数据
        if (this.sellingPlanSelect) {
          for (let i = 0; i < this.sellingPlanSelect.options.length; i++) {
            const opt = this.sellingPlanSelect.options[i];
            console.log(`[SubscriptionWidget] Option ${i}: value=${opt.value}, price=${opt.dataset.price}, comparePrice=${opt.dataset.comparePrice}`);
          }
        }
      }

      setupEventListeners() {
        // 监听订阅方案选择变化
        console.log('[SubscriptionWidget] Setting up event listeners');

        if (this.sellingPlanSelect) {
          console.log('[SubscriptionWidget] Adding change listener to sellingPlanSelect');
          this.sellingPlanSelect.addEventListener('change', (e) => {
            console.log('[SubscriptionWidget] Select change event fired!', e.target.value);
            this.handleSellingPlanChange(e);
          });
        } else {
          console.log('[SubscriptionWidget] WARNING: sellingPlanSelect is null!');
        }

        // 监听一次性购买/订阅单选按钮变化
        this.onetimeRadio?.addEventListener('change', (e) => this.handlePurchaseTypeChange(e));
        this.subscribeRadio?.addEventListener('change', (e) => this.handlePurchaseTypeChange(e));
      }

      // 将 selling_plan input 移动到 product form 内部
      moveSellingPlanInputToForm() {
        if (!this.sellingPlanInput) return;

        const productForm = document.querySelector(`form[data-type="add-to-cart-form"][id^="product-form-${this.sectionId}"]`);
        if (!productForm) return;

        const variantIdInput = productForm.querySelector('input[name="id"].product-variant-id');
        if (variantIdInput && variantIdInput.parentNode) {
          variantIdInput.parentNode.insertBefore(this.sellingPlanInput, variantIdInput.nextSibling);
        } else {
          productForm.appendChild(this.sellingPlanInput);
        }
      }

      handlePurchaseTypeChange(event) {
        const purchaseType = event.target.value;

        if (purchaseType === 'onetime') {
          if (this.sellingPlanInput) {
            this.sellingPlanInput.value = '';
          }
          if (this.sellingPlanSelect) {
            this.sellingPlanSelect.disabled = true;
          }
        } else if (purchaseType === 'subscribe') {
          const firstOption = this.sellingPlanSelect?.options[0];
          if (firstOption && this.sellingPlanInput) {
            this.sellingPlanInput.value = firstOption.value;
          }
          if (this.sellingPlanSelect) {
            this.sellingPlanSelect.disabled = false;
          }
        }

        this.updatePriceDisplay();
      }

      handleSellingPlanChange(event) {
        const sellingPlanId = event.target.value;
        console.log('[SubscriptionWidget] handleSellingPlanChange triggered, sellingPlanId:', sellingPlanId);

        // 当用户选择订阅方案时，自动选中"订阅购买"单选按钮
        if (this.subscribeRadio && !this.subscribeRadio.checked) {
          this.subscribeRadio.checked = true;
          // 取消一次性购买的选中状态
          if (this.onetimeRadio) {
            this.onetimeRadio.checked = false;
          }
        }

        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = sellingPlanId;
        }

        this.updatePriceDisplay();
      }

      updatePriceDisplay() {
        console.log('[SubscriptionWidget] updatePriceDisplay called');
        console.log('[SubscriptionWidget] sellingPlanSelect:', this.sellingPlanSelect);
        console.log('[SubscriptionWidget] subscribePriceDisplay:', this.subscribePriceDisplay);

        // 当选中订阅方案时，更新订阅选项中的价格
        if (this.sellingPlanSelect) {
          const selectedOption = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex];
          console.log('[SubscriptionWidget] selectedOption:', selectedOption);
          console.log('[SubscriptionWidget] selectedOption dataset:', selectedOption?.dataset);

          if (selectedOption) {
            const price = selectedOption.dataset.price ? parseInt(selectedOption.dataset.price, 10) : null;
            const comparePrice = selectedOption.dataset.comparePrice ? parseInt(selectedOption.dataset.comparePrice, 10) : null;
            console.log('[SubscriptionWidget] price:', price, 'comparePrice:', comparePrice);

            // 更新订阅选项中的价格显示
            if (price !== null && this.subscribePriceDisplay) {
              const formattedPrice = this.formatMoney(price);
              console.log('[SubscriptionWidget] Updating price to:', formattedPrice);
              this.subscribePriceDisplay.textContent = formattedPrice;
            }

            // 更新订阅选项中的对比价格
            if (comparePrice && comparePrice > price && this.subscribeComparePriceDisplay) {
              this.subscribeComparePriceDisplay.textContent = this.formatMoney(comparePrice);
              this.subscribeComparePriceDisplay.style.display = '';
            } else if (this.subscribeComparePriceDisplay) {
              this.subscribeComparePriceDisplay.style.display = 'none';
            }
          }
        }
      }

      formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, theme.moneyFormat);
        }
        return '$' + (cents / 100).toFixed(2);
      }
    }
  );
}
